import React, { forwardRef } from 'react';
import styles from './label.module.css';

// Extend the props to include all input attributes
// interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

export const Label = forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, children, ...props }, ref) => {
  return (
    <label
      className={`${styles.label} ${className}`}
      {...props} // Spread all props, allowing standard input attributes
      ref={ref}
    >
      {children}
    </label>
  );
});
